import { TransactionStatus } from '../../../../state/payment/payment.types';
import { PaymentStatusConfig } from './PaymentStatusFailed.types';

export const getStatusConfig = (
  type: Lowercase<TransactionStatus['transactionType']>,
): PaymentStatusConfig => ({
  'try-again': {
    primaryAction: 'goBack',
    secondaryAction: 'openChat',
  },
  'try-again-later': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'contact-support': {
    image: `wallet.${type}Error`,
    imageWidth: 140,
    imageHeight: 65,
    primaryAction: 'goBack',
    secondaryAction: 'openChat',
  },
  'check-your-expiry-date': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'incorrect-card-details': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'incorrect-card-number': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'incorrect-cvv': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'check-your-card-balance-and-try-again': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'another-card-or-payment-method': {
    primaryAction: 'goBack',
    secondaryAction: 'openChat',
  },
  'try-again-or-use-another-payment-method': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'transaction-was-unsuccessful-due-to-insufficient-funds': {
    primaryAction: 'goBack',
    secondaryAction: 'close',
  },
  'exceeded-the-limit-of-250-cad': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'reached-the-daily-deposit-limit': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'deposit-with-interac': {
    primaryAction: 'goBack',
    secondaryAction: 'openChat',
  },
  'try-with-less-amount': {
    primaryAction: 'goBack',
    secondaryAction: 'openChat',
  },
  'use-another-payment-method-with-deposits': {
    primaryAction: 'close',
    secondaryAction: 'openChat',
  },
  'additional-payment-method-verification-required': {},
  'payment-method-document-pending-review': {},
});
